// SubNav primitive — port of design/v3/SettingsPage.jsx:28-63 (서브 탭 네비게이션).

import type { CSSProperties } from 'react';

export interface SubNavItem {
  id: string;
  label: string;
  count?: number;
  icon?: string;
}

export interface SubNavProps {
  items: SubNavItem[];
  active: string;
  onChange: (id: string) => void;
  scrollable?: boolean;
  style?: CSSProperties;
}

export function SubNav({ items, active, onChange, scrollable, style }: SubNavProps) {
  return (
    <div
      style={{
        display: 'flex',
        gap: 4,
        padding: 4,
        background: 'var(--bg-subtle)',
        border: '1px solid var(--border-weak)',
        borderRadius: 10,
        overflowX: scrollable ? 'auto' : 'visible',
        flexWrap: scrollable ? 'nowrap' : 'wrap',
        maxWidth: '100%',
        boxSizing: 'border-box',
        WebkitOverflowScrolling: 'touch',
        ...style,
      }}
    >
      {items.map((it) => {
        const on = it.id === active;
        return (
          <button
            key={it.id}
            type="button"
            onClick={() => onChange(it.id)}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              padding: '7px 12px',
              fontSize: 13,
              fontWeight: on ? 600 : 500,
              fontFamily: 'var(--font-sans)',
              color: on ? 'var(--fg-1)' : 'var(--fg-2)',
              background: on ? 'var(--bg-surface)' : 'transparent',
              border: on ? '1px solid var(--border-base)' : '1px solid transparent',
              borderRadius: 'var(--radius-md)',
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              flexShrink: 0,
              boxShadow: on ? 'var(--shadow-xs)' : 'none',
              transition: 'all var(--dur-base) var(--ease-out)',
              minHeight: 'var(--control-min-h)',
            }}
          >
            <span>{it.label}</span>
            {it.count != null && (
              <span
                style={{
                  fontSize: 11,
                  fontWeight: 600,
                  fontVariantNumeric: 'tabular-nums',
                  color: on ? 'var(--primary-strong)' : 'var(--fg-3)',
                  background: on ? 'var(--primary-bg)' : 'var(--bg-surface)',
                  border: `1px solid ${on ? 'var(--primary-border)' : 'var(--border-weak)'}`,
                  padding: '0 6px',
                  borderRadius: 'var(--radius-full)',
                  minWidth: 18,
                  textAlign: 'center',
                }}
              >
                {it.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
